import { SET_KEY_OUTIN_RECORDS, SET_KEY_LOST_RECORDS } from '../constants/KeyRecordConstants';

const initialState = {
  outinDatas: {
    list: [],
    count: 0,
  },
  lostDatas: {
    list: [],
    count: 0,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_KEY_OUTIN_RECORDS: {
      return {
        ...state,
        outinDatas: {
          list: action.payload.list,
          count: action.payload.count,
        },
      };
    }

    case SET_KEY_LOST_RECORDS: {
      return {
        ...state,
        lostDatas: {
          list: action.payload.list,
          count: action.payload.count,
        },
      };
    }

    default: {
      return state;
    }
  }
}
